module.exports = __webpack_public_path__ + "static/media/IMG_1210.a69d633b.jpg";